import { render, staticRenderFns } from "./AddIndustryPopup.vue?vue&type=template&id=5f8296f0&"
import script from "./AddIndustryPopup.vue?vue&type=script&lang=js&"
export * from "./AddIndustryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports